/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    // Don't think this does anything now. - Si
    this.blockMembershipATC();

    $(document).on('click', '.ajax-submit', async function (e) {
      console.log("ajax-submit")
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      const cart = await Shopify.theme.jsAjaxCart.getCart();
      let productType = null;
      if(e.target.tagName === "BUTTON"){
        productType = e.target.dataset.productType;
      } else {
        productType = e.target.closest('button').dataset.productType;
      }

      console.log({
        hasMembershipInCart: cart.items.some(item =>
          item.product_type?.toLowerCase().includes("membership")
        ),
        productType,
        isMember: window.odTheme.customer.isMember,
        conditionResult:
          (cart.items.some(item => item.product_type?.toLowerCase().includes("membership")) &&
            productType === "Membership" &&
            window.odTheme.customer.isMember === false) ||
          (window.odTheme.customer.isMember === true && productType === "Membership")
      });      

      if((cart.items.some(item => item.product_type?.toLowerCase().includes("membership")) && productType === "Membership" && window.odTheme.customer.isMember === false) || window.odTheme.customer.isMember === true && productType === "Membership"){
        const userMessage = e.target.closest('form').querySelector('[data-user-message]');
        if (userMessage) {
          userMessage.querySelector('p').innerHTML = "You are buying a membership for yourself. If you want to buy a membership for someone else, please contact Customer Service";
          userMessage.classList.remove("hidden");
        }
        return false;
      }
      
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
      return false;
    });

    $(document).on('click', '[data-ajax-cart-delete]', async function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      Shopify.theme.jsAjaxCart.removeFromCart(lineID);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();

      return false;
    });

    $(document).on('click', '[data-add-to-cart]', async function (e) {
      e.preventDefault();
      event.target.classList.add('loading');
      let properties = {
      };
      let productType = null;
      if(e.target.tagName === "BUTTON"){
        productType = e.target.dataset.productType;
      } else {
        productType = e.target.closest('button').dataset.productType;
      }
      for (var i = 0; i < Object.keys(event.target.dataset).length; i++) {
        var key = Object.keys(event.target.dataset)[i];

        if (key.indexOf('properties_') > -1){
          var name = key.replace('properties','');
          var value = event.target.dataset[Object.keys(event.target.dataset)[i]];
          //check if numeric
          function isNumeric(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
          }
          if (isNumeric(value)){
            if (value.indexOf('.') > -1){
              value = parseFloat(value);
            }
            else {
              value = parseInt(value);
            }
          }
          
          if (value.length <= 0){
            value = null;
          }

          properties[name] = value;
        }
      }

      var parent = event.target.parentElement;
      var quantity = 1;
      if(parent){
        var inputNumber = parent.querySelector('input[name="quantity"]');
        if(inputNumber)
          quantity = parseInt(inputNumber.value);
      }
      const cart = await Shopify.theme.jsAjaxCart.getCart();
      if((cart.items.some(item => item.product_type?.toLowerCase().includes("membership")) && productType === "Membership" && window.odTheme.customer.isMember === false) || window.odTheme.customer.isMember === true && productType === "Membership"){
        const userMessage = parent.querySelector('[data-user-message]');
        const promocart = parent.closest('.product__thumbnail.product__promo-item');
        if (userMessage) {
          const closeButton = userMessage.querySelector('[data-user-message-close]');
          function closeMessage() {
            userMessage.classList.add('hidden');
            if(promocart){
              promocart.classList.remove('show-message');
            }
          }
          userMessage.querySelector('p').innerHTML = "You are buying a membership for yourself. If you want to buy a membership for someone else, please contact Customer Service";
          userMessage.classList.remove("hidden");
          if(promocart){
            promocart.classList.add('show-message');
          }
          closeButton.removeEventListener('click', closeMessage);
          closeButton.addEventListener('click', closeMessage);
        }
        e.target.classList.remove('loading');
        return false;
      }
      
      Shopify.theme.jsAjaxCart.addSingleToCart(this.dataset.addToCart, quantity, properties, event.target,this.dataset.sellingPlan);

      e.target.classList.remove('loading');

      return false;
    });
  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        var event = new CustomEvent("cart:updated", { cart: product });
        document.dispatchEvent(event);
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  initializeAjaxCart: function () {

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        // Converting the currencies
        if (Shopify.theme.currencyConverter) {
          Shopify.theme.currencyConverter.convertCurrencies();
        }

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

      })
      .fail(() => {
        // some error handling
      });
  },
  getCart: async function(){

    return new Promise(function(resolve, reject) {

      $.ajax({
        url: '/cart.json',
        success: function (data) {

          var cart = data;
          
          
          return resolve(cart);

        },
        error: function (XMLHttpRequest) {
          return resolve(); 
        }
      });
      
    });

  },
  addSingleToCart: function(variantId,quantity,properties = {}, button, sellingPlan){
    $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: { items: [
            {
              id: variantId, 
              quantity: quantity,
              properties: properties,
              selling_plan: sellingPlan

            }
          ]
        },
        beforeSend: function () {

        },
        success: function (product) {

          var event = new CustomEvent("cart:updated", { cart: product });
          document.dispatchEvent(event);
          let $el = $('[data-ajax-cart-trigger]');

          var warningContainer = $('body').find('.cart-warning');
          warningContainer.addClass('hidden');

          function addedToCart() {

            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              Shopify.theme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

            $el.addClass('show-mini-cart');

          }

          Shopify.theme.jsAjaxCart.showDrawer();
          Shopify.theme.jsAjaxCart.updateView();
          if(button)
            button.classList.remove('loading');
            
          if (Shopify.theme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: function (XMLHttpRequest) {
          let response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;

          const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;

          $('.warning').remove();
          var warningContainer = $('body').find('.cart-warning');
          warningContainer.html(cartWarning);
          warningContainer.removeClass('hidden');

        }
      });
  },
  addMultipleToCart: function(products,callback){
    $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: { items: products },
        beforeSend: function () {

        },
        success: function (product) {

          var event = new CustomEvent("cart:updated", { cart: product });
          document.dispatchEvent(event);
          let $el = $('[data-ajax-cart-trigger]');

          // $addToCartBtn
          //   .find('.checkmark')
          //   .addClass('checkmark-active');
          var warningContainer = $('body').find('.cart-warning');
          warningContainer.addClass('hidden');

          function addedToCart() {

            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              Shopify.theme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

            $el.addClass('show-mini-cart');

            // $addToCartBtn.find('span')
            //   .removeClass('fadeInDown');
          }

          callback()

          window.setTimeout(function () {
            // $addToCartBtn
            //   .removeAttr('disabled')
            //   .removeClass('disabled');

            // $addToCartBtn.find('.checkmark')
            //   .removeClass('checkmark-active');

            // $addToCartBtn.find('.text, .icon')
            //   .removeClass('zoomOut')
            //   .addClass('fadeInDown');

            // $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          Shopify.theme.jsAjaxCart.showDrawer();
          Shopify.theme.jsAjaxCart.updateView();

          if (Shopify.theme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: function (XMLHttpRequest) {
          let response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;

          const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;

          $('.warning').remove();
          var warningContainer = $('body').find('.cart-warning');
          warningContainer.html(cartWarning);
          warningContainer.removeClass('hidden');
          // $addToCartBtn
          //   .removeAttr('disabled')
          //   .removeClass('disabled');

          // $addToCartBtn.find('.icon')
          //   .removeClass('zoomOut')
          //   .addClass('zoomIn');

          // $addToCartBtn
          //   .find('span:not(.icon)')
          //   .text($addToCartBtn.data('label'))
          //   .removeClass('zoomOut')
          //   .addClass('zoomIn');

          callback()
        }
      });
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${Shopify.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {

          var event = new CustomEvent("cart:updated", { cart: product });
          document.dispatchEvent(event);
          
          let $el = $('[data-ajax-cart-trigger]');

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          function addedToCart() {

            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              Shopify.theme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

            $el.addClass('show-mini-cart');

            $addToCartBtn.find('span')
              .removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          Shopify.theme.jsAjaxCart.showDrawer();
          Shopify.theme.jsAjaxCart.updateView();

          if (Shopify.theme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: function (XMLHttpRequest) {
          let response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          
          const cartWarning = `<p class="cart-warning__message animated bounceIn">${response}</p>`;

          $('.warning').remove();

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },
  updateView: function () {

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {
     
      if (options.item_count > 0) {
        
        const itemList = $(html.content).find('.ajax-cart__list');
        const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');

        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      if (Shopify.theme.currencyConverter) {
        Shopify.theme.currencyConverter.convertCurrencies();
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  },
  blockMembershipATC: async function() {
    const membershipATC = document.querySelectorAll('.select-membership-atc .pf-product-form');
    const cart = await Shopify.theme.jsAjaxCart.getCart();
    const isMembershipInCart = cart.items.some(item => item.product_type?.toLowerCase().includes("membership"));
    // console.log("isMembershipInCart", isMembershipInCart);
    // Remove logic to disable membership ATC buttons https://www.wrike.com/open.htm?id=4316123804
    // if((isMembershipInCart && window.odTheme.customer.isMember === false) || window.odTheme.customer.isMember === true){
    //   membershipATC.forEach(form => {
    //     form.querySelector('button').disabled = true;
    //     form.querySelector('button').classList.add('disabled');
    //   });
    // } else {
    //   membershipATC.forEach(form => {
    //     form.querySelector('button').disabled = false;
    //     form.querySelector('button').classList.remove('disabled');
    //   });
    // }
  }
}

/******/ })()
;
